import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const updateTxnStatusReq = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.holdOrRelease),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: data,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateTxnStatusReq }
